import { PageType } from "../../../config/page.types";
import PlaceholderView from "../../PlaceholderView";

const MasterDataNetworksRoutes = () => {
	return <PlaceholderView pageType={PageType.MasterDataNetworksRoutes} text="Networks & Routes" />;
};

export default MasterDataNetworksRoutes;
